import React from 'react';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import * as R from 'ramda';
import { withTheme } from 'emotion-theming';
import cn from 'classnames';

import { trackClick } from '../../common/tracking-utils';
import { qaSel } from '../../common/utils';
import { onDiscoursePageChange, isCurrPageWithOverrides, isContentSection } from '../../common/discourse-utils';
import styles from './style.css';
import ContentSectionsDropDown from './content-sections-dropdown';
import { Link } from './style.js';

let navItemContainerRef = null;
/* eslint no-undef: "off" */
const maxMenuWidth = window.contentSectionMaxWidth || 472;

const isSelected = (currentPageOverride, feature) => isCurrPageWithOverrides(
  currentPageOverride[feature.path],
  Object.keys(currentPageOverride).length !== 0,
  feature.type
);

const setNavItemDataId = (currentPageOverride, feature) => {
  const isActive = isSelected(currentPageOverride, feature) ? ' c-active' : '';
  return `c-nav-item ${isActive}`;
};

const Links = compose(
  withTheme,
  withState('currentPageOverride', 'setCurrentPageOverride', {}),
  withState('reachedMaxMenuWidth', 'setReachedMaxMenuWidth', false),
  withHandlers({
    onDiscourseEvent: ({ setCurrentPageOverride, features }) => e => {
      setCurrentPageOverride(onDiscoursePageChange(e, features));
    }
  }),
  lifecycle({
    componentDidMount() {
      document.addEventListener('discourse-page-change', this.props.onDiscourseEvent);

      if (navItemContainerRef.offsetWidth >= maxMenuWidth) {
        this.props.setReachedMaxMenuWidth(true);
      }

      const event = new Event('nav-loaded', { bubbles: true });
      document.getElementById('nav-container').dispatchEvent(event);
    },
    componentWillUnmount() {
      document.removeEventListener('discourse-page-change', this.props.onDiscourseEvent);
    }
  })
)(({ features, currentPageOverride, reachedMaxMenuWidth }) => {
  const standAloneLinks = reachedMaxMenuWidth ? R.reject(isContentSection, features) : features;
  const dropDownLinks = reachedMaxMenuWidth ? R.filter(isContentSection, features) : [];

  return (
    <div id="nav-container" className={cn(styles.container, 'c-nav-list-container')}>
      <ul
        ref={node => navItemContainerRef = node}
        data-qa={qaSel('features')}
        className={cn(styles.navList, 'c-nav-list')}>
        {standAloneLinks.map(feature => (
          <li className={cn(styles.navListItem, 'c-nav-list-item')} key={feature.type}>
            <Link
              type={feature.type}
              data-qa={qaSel(`top-nav-link-${feature.type}`)}
              href={feature.path}
              onClick={trackClick(feature.type)}
              selected={isSelected(currentPageOverride, feature)}
              className={setNavItemDataId(currentPageOverride, feature)}>
              {feature.label}
            </Link>
          </li>
        ))}
        {dropDownLinks.length > 0 && <ContentSectionsDropDown
          sectionsForDrownDown={dropDownLinks}
          currentPageOverride={currentPageOverride}>
        </ContentSectionsDropDown>}
      </ul>
    </div>
  );
});

export default Links;
